import React from "react";
import { Link } from "react-router-dom";
import footerImage from "../../template/images/footer_img.png";
import footerLogo from "../../template/images/powered_by.png";
import "./layout.css";
import "./accessibility.css";

const Footer = () => {
  return (
    <React.Fragment>
      <div className="footer_outer">
        <div className="container-lg">
          <div className="footer_inner">

            <div>
              <p className="powered_by">Powered by</p>
              <img
                src={footerLogo}
                alt="Brand Logo"
                className="img-fluid footer_brand_logo"
              />

              <div className="address_main">
              <div className="addres_info">
                <p>Finlabs India Private Limited</p>
              </div>
            </div>
            </div>

            <div className="footer_image_main">
              <img src={footerImage} className="img-fluid footer_image" alt="footer"/>
            </div>

          </div>
        </div>
      </div>
      <div className="footer_lower"></div>
    </React.Fragment>
  );
};

export default Footer;
